import cloneDeep from 'lodash/cloneDeep';
import config from '../main/appointments/config';

const barberConfig = cloneDeep(config);

barberConfig.list.url = `/barber${config.list.url}`;
barberConfig.sideBySide.url = `/barber${config.sideBySide.url}`;
barberConfig.agendaWeek.url = `/barber${config.agendaWeek.url}`;
barberConfig.sideBySide.text = 'Day';

delete barberConfig.day;

export default barberConfig;
